import * as yup from 'yup';
import BankAccountDetails from './BankAccountDetails';
import employeeDetails from './employeeDetails';



export const validationSchema = yup.object({
  ...employeeDetails,
  ...BankAccountDetails,
});